import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { createUploadLink } from 'apollo-upload-client';
import { API_URL } from '../Constants/Config';

export const createClient = (token: string) => {
  const cache = new InMemoryCache();

  const link = createUploadLink({
    uri: `${API_URL}/graphql`,
    headers: {
      authorization: token ? `Bearer ${token}` : '',
    },
  }) as unknown as ApolloLink;

  return new ApolloClient({
    // Provide required constructor fields
    cache: cache,
    // link: authLink.concat(httpLink),
    link,

    // Provide some optional constructor fields
    name: 'react-web-client',
    version: '1.3',
    queryDeduplication: false,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'cache-and-network',
      },
    },
  });
};
